import { gql } from "@apollo/client";

export const GET_ASSET_BENCHMARKS = gql`
    query GetLegacyNextAssetBenchmarks($bfe: String!) {
        getLegacyNextAssetBenchmarks(bfe: $bfe) {
            segment
            numberOfBuildings
            co2BenchmarkMethod1
            bfe
            benchmarkType
            benchmarkId
        }
    }
`;
